// Tenant Configuration - Arena only
export const tenants = {
  arena: {
    id: "arena",
    name: "Arena Esports",
    agentName: "ArenaClaw",
    tagline: "Your Esports Assistant",
    logo: "https://arenaesports.ae/images/brandIcon.png",
    colors: {
      primary: "#00D4AA",
      primaryHover: "#00E6BB",
      secondary: "#6366F1",
      background: "#0F172A",
      surface: "#1E293B",
      surfaceHover: "#334155",
      border: "#475569",
      text: "#F8FAFC",
      textMuted: "#94A3B8"
    },
    features: {
      tournaments: true,
      support: true,
      sales: true,
      analytics: true
    },
    welcomeMessage: "Hey! I'm ArenaClaw, your Arena Esports assistant. I can help you find tournaments, answer questions, or get support. What do you need?",
    supportEmail: "support@arenaesports.ae",
    website: "https://arenaesports.ae"
  }
};

export const getTenant = (tenantId) => {
  return tenants[tenantId] || tenants.arena;
};

export const defaultTenant = "arena";
